(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['one-brandkey'] = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    /** @deprecated */
    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    (function (Unit) {
        Unit["BIN"] = "BIN";
        Unit["CAM"] = "CAM";
        Unit["CEBR"] = "CEBR";
        Unit["CEDE"] = "CEDE";
        Unit["CEES"] = "CEES";
        Unit["CEIT"] = "CEIT";
        Unit["CEUK"] = "CEUK";
        Unit["FRGTS"] = "FRGTS";
        Unit["FROMM"] = "FROMM";
        Unit["GALA"] = "GALA";
        Unit["GEO"] = "GEO";
        Unit["NEON"] = "NEON";
        Unit["NGE"] = "NGE";
        Unit["PECO"] = "PECO";
        Unit["PFEM"] = "PFEM";
        Unit["PTVS"] = "PTVS";
        Unit["TRV"] = "TRV";
        Unit["VOICI"] = "VOICI";
        Unit["TESTUNIT"] = "TEST-UNIT";
    })(exports.Unit || (exports.Unit = {}));
    function isUnit(maybeUnit) {
        return Object.entries(exports.Unit).some(function (_a) {
            var unit = _a[1];
            return unit === maybeUnit;
        });
    }
    function assertUnit(maybeUnit) {
        if (!isUnit(maybeUnit)) {
            throw new Error("The unit \"" + maybeUnit + "\" does not exist.");
        }
        return maybeUnit;
    }

    var _a, _b;
    (function (BrandKey) {
        BrandKey["ATN"] = "ATN";
        BrandKey["BEA"] = "BEA";
        BrandKey["BIN"] = "BIN";
        BrandKey["BRGTS"] = "BRGTS";
        BrandKey["BROMM"] = "BROMM";
        BrandKey["CAC"] = "CAC";
        BrandKey["CAM"] = "CAM";
        BrandKey["CAP"] = "CAP";
        BrandKey["CTP"] = "CTP";
        BrandKey["DEGTS"] = "DEGTS";
        BrandKey["DEOMM"] = "DEOMM";
        BrandKey["ESGTS"] = "ESGTS";
        BrandKey["ESOMM"] = "ESOMM";
        BrandKey["FAC"] = "FAC";
        BrandKey["FLW"] = "FLW";
        BrandKey["FRGTS"] = "FRGTS";
        BrandKey["FRGSD"] = "FRGSD";
        BrandKey["FRGSG"] = "FRGSG";
        BrandKey["FRGSL"] = "FRGSL";
        BrandKey["FRGSS"] = "FRGSS";
        BrandKey["FRGSV"] = "FRGSV";
        BrandKey["FROMM"] = "FROMM";
        BrandKey["GAL"] = "GAL";
        BrandKey["GEO"] = "GEO";
        BrandKey["HBR"] = "HBR";
        BrandKey["ITGTS"] = "ITGTS";
        BrandKey["ITOMM"] = "ITOMM";
        BrandKey["MAN"] = "MAN";
        BrandKey["NEO"] = "NEO";
        BrandKey["NGE"] = "NGE";
        BrandKey["OMM"] = "OMM";
        BrandKey["PRA"] = "PRA";
        BrandKey["SRG"] = "SRG";
        BrandKey["TEL"] = "TEL";
        BrandKey["TGC"] = "TGC";
        BrandKey["TLA"] = "TLA";
        BrandKey["TLS"] = "TLS";
        BrandKey["TRV"] = "TRV";
        BrandKey["TVJ"] = "TVJ";
        BrandKey["UKGTS"] = "UKGTS";
        BrandKey["UKOMM"] = "UKOMM";
        BrandKey["VOI"] = "VOI";
        BrandKey["TESTBRAND"] = "TEST-BRAND";
        // legacy articles access for ADMIN only
        BrandKey["CTR"] = "CTR";
        BrandKey["VDF"] = "VDF";
    })(exports.BrandKey || (exports.BrandKey = {}));
    var brandKeysByUnit = (_a = {},
        _a[exports.Unit.BIN] = [exports.BrandKey.BIN],
        _a[exports.Unit.CAM] = [exports.BrandKey.CAM],
        _a[exports.Unit.CEBR] = [exports.BrandKey.BRGTS, exports.BrandKey.BROMM],
        _a[exports.Unit.CEDE] = [exports.BrandKey.DEGTS, exports.BrandKey.DEOMM],
        _a[exports.Unit.CEES] = [exports.BrandKey.ESGTS, exports.BrandKey.ESOMM],
        _a[exports.Unit.CEIT] = [exports.BrandKey.ITGTS, exports.BrandKey.ITOMM],
        _a[exports.Unit.CEUK] = [exports.BrandKey.UKGTS, exports.BrandKey.UKOMM],
        _a[exports.Unit.FRGTS] = [
            exports.BrandKey.FRGTS,
            exports.BrandKey.FRGSD,
            exports.BrandKey.FRGSG,
            exports.BrandKey.FRGSL,
            exports.BrandKey.FRGSS,
            exports.BrandKey.FRGSV,
        ],
        _a[exports.Unit.FROMM] = [exports.BrandKey.FROMM],
        _a[exports.Unit.GALA] = [exports.BrandKey.GAL],
        _a[exports.Unit.GEO] = [exports.BrandKey.GEO],
        _a[exports.Unit.NEON] = [exports.BrandKey.NEO],
        _a[exports.Unit.NGE] = [exports.BrandKey.NGE],
        _a[exports.Unit.PECO] = [exports.BrandKey.ATN, exports.BrandKey.CAP, exports.BrandKey.HBR, exports.BrandKey.MAN],
        _a[exports.Unit.PFEM] = [
            exports.BrandKey.BEA,
            exports.BrandKey.CAC,
            exports.BrandKey.FAC,
            exports.BrandKey.FLW,
            exports.BrandKey.OMM,
            exports.BrandKey.PRA,
            exports.BrandKey.SRG,
        ],
        _a[exports.Unit.PTVS] = [
            exports.BrandKey.CTP,
            exports.BrandKey.CTR,
            exports.BrandKey.TEL,
            exports.BrandKey.TGC,
            exports.BrandKey.TLA,
            exports.BrandKey.TLS,
            exports.BrandKey.TVJ,
        ],
        _a[exports.Unit.TRV] = [exports.BrandKey.TRV],
        _a[exports.Unit.VOICI] = [exports.BrandKey.VOI],
        _a[exports.Unit.TESTUNIT] = [exports.BrandKey.CTR, exports.BrandKey.VDF, exports.BrandKey.TESTBRAND],
        _a);
    var brandTitleByKey = (_b = {},
        _b[exports.BrandKey.ATN] = 'Athenee',
        _b[exports.BrandKey.BEA] = 'Beauté Addict',
        _b[exports.BrandKey.BIN] = 'Business insider',
        _b[exports.BrandKey.BRGTS] = 'BR Gentside',
        _b[exports.BrandKey.BROMM] = 'BR Ohmymag',
        _b[exports.BrandKey.CAC] = 'Cuisine Actuelle',
        _b[exports.BrandKey.CAM] = "Ça m'intéresse",
        _b[exports.BrandKey.CAP] = 'Capital',
        _b[exports.BrandKey.CTP] = '100% programme TV',
        _b[exports.BrandKey.CTR] = 'Ciné Télé Revue',
        _b[exports.BrandKey.DEGTS] = 'DE Gentside',
        _b[exports.BrandKey.DEOMM] = 'DE Ohmymag',
        _b[exports.BrandKey.ESGTS] = 'ES Gentside',
        _b[exports.BrandKey.ESOMM] = 'ES Ohmymag',
        _b[exports.BrandKey.FAC] = 'Femme Actuelle',
        _b[exports.BrandKey.FLW] = 'Flow',
        _b[exports.BrandKey.FRGTS] = 'FR Gentside',
        _b[exports.BrandKey.FRGSD] = 'FR Gentside Découverte',
        _b[exports.BrandKey.FRGSG] = 'FR Gentside Gaming',
        _b[exports.BrandKey.FRGSL] = 'FR Gentside Lifestyle',
        _b[exports.BrandKey.FRGSS] = 'FR Gentside Sport',
        _b[exports.BrandKey.FRGSV] = 'FR Gentside Voyage',
        _b[exports.BrandKey.FROMM] = 'FR Ohmymag',
        _b[exports.BrandKey.GAL] = 'Gala',
        _b[exports.BrandKey.GEO] = 'GEO',
        _b[exports.BrandKey.HBR] = 'Harvard Business Review',
        _b[exports.BrandKey.ITGTS] = 'IT Gentside',
        _b[exports.BrandKey.ITOMM] = 'IT Ohmymag',
        _b[exports.BrandKey.MAN] = 'Management',
        _b[exports.BrandKey.NEO] = 'Néon',
        _b[exports.BrandKey.NGE] = 'National Geographic',
        _b[exports.BrandKey.OMM] = 'Ohmymag',
        _b[exports.BrandKey.PRA] = 'Prima',
        _b[exports.BrandKey.SRG] = 'Femme Actuelle Senior',
        _b[exports.BrandKey.TEL] = 'Télé-loisirs',
        _b[exports.BrandKey.TGC] = 'TV Grandes chaines',
        _b[exports.BrandKey.TLA] = 'Télé-loisirs Afrique',
        _b[exports.BrandKey.TLS] = 'Télé 2 semaines',
        _b[exports.BrandKey.TRV] = 'Transverse',
        _b[exports.BrandKey.TVJ] = 'Télé + de jeux + lisible',
        _b[exports.BrandKey.UKGTS] = 'UK Gentside',
        _b[exports.BrandKey.UKOMM] = 'UK Ohmymag',
        _b[exports.BrandKey.VDF] = 'Vie de Famille',
        _b[exports.BrandKey.VOI] = 'Voici',
        _b[exports.BrandKey.TESTBRAND] = 'Test brand',
        _b);
    function isBrandKey(maybeBrandKey) {
        return Object.entries(exports.BrandKey).some(function (_a) {
            var brandKey = _a[1];
            return brandKey === maybeBrandKey;
        });
    }
    function assertBrandKey(maybeBrandKey) {
        if (!isBrandKey(maybeBrandKey)) {
            throw new Error("The brandKey \"" + maybeBrandKey + "\" does not exist.");
        }
        return maybeBrandKey;
    }
    function getBrandKeysForUnits(units) {
        return units.reduce(function (brandKeys, unit) { return __spreadArrays(brandKeys, brandKeysByUnit[unit]); }, []);
    }

    exports.assertBrandKey = assertBrandKey;
    exports.assertUnit = assertUnit;
    exports.brandKeysByUnit = brandKeysByUnit;
    exports.brandTitleByKey = brandTitleByKey;
    exports.getBrandKeysForUnits = getBrandKeysForUnits;
    exports.isBrandKey = isBrandKey;
    exports.isUnit = isUnit;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
